// extracted by mini-css-extract-plugin
export var clickThrough = "_xt-2";
export var fallback = "_xt-5";
export var frame = "_xt-3";
export var frameCell = "_xt-1";
export var overlay = "_xt-4";
export var wrapper = "_xt-0";